export default __webpack_public_path__ + "static/media/inventory.56c9227f.svg";